import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const FAQS = [{
  question: 'How many people can stay overnight?',
  answer: 'The retreat stay accommodates up to six guests.'
}, {
  question: 'Where can I book?',
  answer: 'You can book through Airbnb or Booking.com, or message Zev on WhatsApp if you have a question before booking.'
}, {
  question: 'Can I combine an overnight stay with a gathering?',
  answer: '[Confirm with Zev] Availability and use of the sauna, dome, pool, and other retreat facilities depend on the dates and type of gathering.'
}, {
  question: 'Is there parking?',
  answer: 'Parking is available on site. [Replace with any arrival or access notes you would like guests to receive before booking.]'
}];
export function StayFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-249" data-mp="1u34ad6seb348">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-250" data-mp="7i1k75k40ciz">
        <div data-id="element-251" data-mp="2jqaqvxq841a">
          <FadeIn data-id="element-252" data-mp="2k9ixkxkre24">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-253" data-mp="2kroj864n4mp">
              Stay FAQ
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-254" data-mp="cho05mrbo6vh">
            <h2 className="font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-255" data-mp="cgcutii8ar29">
              A few useful details before you arrive.
            </h2>
          </FadeIn>
        </div>

        <div className="border-t border-pine/15" data-id="element-256" data-mp="lahftlaol89v">
          {FAQS.map((faq, index) => {
          const isOpen = index === openIndex;
          return <FadeIn key={faq.question} delay={index * 0.06} data-id="element-257" data-mp="104mby74hyqn2" data-mpi={index}>
                <div className="border-b border-pine/15" data-id="element-258" data-mp="v8f4ub0d793j">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 py-5 text-left text-pine" aria-expanded={isOpen} data-id="element-259" data-mp="31xtppc4gp06u">
                    <span className="font-medium" data-id="element-260" data-mp="3qog50t93acz7">{faq.question}</span>
                    <ChevronDown className={`h-5 w-5 flex-none transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-261" data-mp="3qqsvxvwtrxoe" />
                  </button>
                  {isOpen && <p className="max-w-2xl pb-5 font-light leading-relaxed text-clay" data-id="element-262" data-mp="4j2r7o3y4wg8">
                      {faq.answer}
                    </p>}
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}